import LookupAdminItem from '../Domain/LookupAdminItem';
import AuthService from './authService';

class LookupItemService
{
  static GetLookupItemListByLookupId (lookupId)
  {
    let url = '/api/LookupItem';
    url += lookupId ? `/?lookupId=${lookupId}&clearCache=false` : '?clearCache=false';

    const authService = AuthService.getInstance();

    return authService.CallBackendFunction(url);
  }

  static GetLookupItemListById (lookupId, orderById, orderDir)
  {
    const url = `/api/LookupItem/GetAllLookupItems/${lookupId}?orderById=${orderById}&orderDir=${orderDir}&clearCache=false`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static PostLookupItem (data)
  {
    data.IsActive = data.IsActive === true || data.IsActive === 'true' ? 'true' : 'false';

    if (data.Order != null) data.Order = data.Order.toString();

    return AuthService.getInstance().CallBackendFunctionPost('/api/LookupItem/PostLookupAsync', JSON.stringify(data));
  }

  static async GetLookupItemByLookupIdAndLookupItemId (lookupId, lookupItemId)
  {
    const response = await LookupItemService.GetLookupItemListByLookupId(lookupId);
    return response.find((r) => r.value.toString() === lookupItemId.toString());
  }

  static ConvertDBLookupAdminItem (items)
  {
    const convertedItems = [];
    if (items !== null)
    {
      items.forEach((item) =>
      {
        const newItem = new LookupAdminItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static async GetLookupItemByLookupIdAndLookupValue (lookupId, value)
  {
    if (!value) return { lookupItemId: 0, text: '', value: '' };
    const response = await LookupItemService.GetLookupItemListByLookupId(lookupId);
    return response.find((r) => r.value.toString() === value.toString());
  }

  static async GetLookupItemByLookupIdAndLookupValueArray (lookupId, valueArray)
  {
    const list = await LookupItemService.GetLookupItemListByLookupId(lookupId);
    const values = valueArray.split('^');
    const result = values.map((value) => list.find((r) => r.value.toString() === value.toString()).text);
    //response.find(r=>r.value.toString()===lookupItemId.toString());
    return {
      text: result.join(', '),
      valueArray,
    };
  }

  static async GetLookupItemByLookupIdAndLookupItemIdValueArray (lookupId, valueArray)
  {
    const list = await LookupItemService.GetLookupItemListByLookupId(lookupId);

    const result = valueArray.map((value) => list.find((r) => r.lookupItemId.toString() === value.toString()).text);
    return {
      text: result.join(', '),
      valueArray,
    };
  }

  static GetLookupItemsByLookupId (lookupId)
  {
    return AuthService.getInstance().CallBackendFunction(`/api/LookupItem/GetLookupItemsByLookupId/${lookupId}`);
  }

  static GetLookupItemById (lookupItemId)
  {
    return AuthService.getInstance().CallBackendFunction(`/api/LookupItem/GetLookupItemById/${lookupItemId}`);
  }

  static GetCostGroups ()
  {
    return AuthService.getInstance().CallBackendFunction('/api/CostGroup/GetCostGroups');
  }
}

export default LookupItemService;
